import { getImageUrl, useGetImageUrl } from 'ui-images';

/**
 * This is a constant that returns a url for the robot-small illustration.
 * @deprecated use useMrHubBot instead
 */
export const mrHubBot = getImageUrl('robot-small');

/**
 * This is a hook that returns a url for the robot-small illustration.
 * It uses the useGetImageUrl hook from ui-images to get the image url, which is a theme-aware version of getImageUrl and returns a different URL for an illustration based on the theme.
 * @returns the image url for robot-small illustration
 * @example
 * ```tsx
 * const mrHubBot = useMrHubBot();
 * <Avatar src={mrHubBot} />
 * ```
 */
export const useMrHubBot = () => {
  return useGetImageUrl("robot-small");
};